import { render } from "./PagePopup.vue?vue&type=template&id=557b0c13"
import script from "./PagePopup.vue?vue&type=script&lang=js"
export * from "./PagePopup.vue?vue&type=script&lang=js"

import "./PagePopup.vue?vue&type=style&index=0&id=557b0c13&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__